// Copyright (c) 2015, Neo Pacific Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

if (!window.fusionerp) window.fusionerp = {};

fusionerp.subscribe_to_newsletter = function (opts, btn) {
	return nxf.call({
		type: "POST",
		method: "nxf.email.doctype.newsletter.newsletter.subscribe",
		btn: btn,
		args: { email: opts.email },
		callback: opts.callback,
	});
};
